// extracted by mini-css-extract-plugin
export default {"search":"search___Zf1ho","darkSearch":"darkSearch___xVQW2"};